export default __webpack_public_path__ + "static/media/sticker_how.99cc7b41.svg";